export enum DemandeCongeStatut {
  En_Cour,
  Accepter,
  Annuler,
  Refuser,
  Holiday_Canceled,
  Automatic,
}

interface ResponseStatsConge {
  inHoliday: number;
  rejected: number;
  accepted: number;
  demandeCount: number;
  range_Min: number;
  range_Max: number;
  typeConge: string[];
  status: string[];
  nbrJour: number[];
}

interface FilterDetails {
  dataSourceId?: string | null;
  typeConge?: number[];
  status?: number[];
  range_min?: number | null;
  range_max?: number | null;
  date_created_min?: string | null;
  date_created_max?: string | null;
  site?: number[];
  society?: number[];
}

interface TableFilter {
  start: number;
  length: number;
  search: {
    value: string;
    regex: boolean;
  };
  order: {
    column: string;
    dir: string;
    custom: boolean;
  }[];
  filters: FilterDetails;
}
interface UserData {
  id: number;
  user: User;
  type: string;
  createdDate: string;
  startDate: string;
  endDate: string;
  totalDays: number;
  status: string;
}

interface User {
  value: string;
  text: string;
  smallText: string;
  imagePath: string;
  labelGroup?: string | null;
  valueGroup: string;
  selected: boolean;
  type?: string | null;
  date?: string | null;
  order?: number | null;
}

interface MainResponse {
  id: number;
  fk_RegimeType: number;
  startDate: Date;
  endDate: Date;
  createdDate: string;
  morning: boolean;
  afternoon: boolean;
  solde: number;
  description: string;
  files: File[] | null;
  filesContent: FileType[];
  filesNames: FileType[];
  statut: string;
  durationValue: number;
  isEditable: boolean;
  descriptionRequired: boolean;
  substituteRequired: boolean;
  substituteVisible: boolean;
  canApproved: boolean;
  approbateur: boolean;
  type: string;
  typeColor: string | null;
  city: string;
  replacedBy: string | null;
  fk_User: string;
  fk_Substitute: string | null;
  levelType: string;
  profiles: unknown | null;
  types: unknown | null;
  usersList: SelectItem[] | null;
  daysOff: string[] | null;
  startTime: string | null;
  endTime: string | null;
  isExcatTimeRequired: boolean;
  daysBeforeRequest: string | null;
  createBy: CreateBy;
  approval: Approval[];
  demanedInSameDepartment: UserDep[];
  demandeUser: DemandeUser;
  fk_droit: number;
  durationUnit: number;
  projectId: number;
  projectName: string;
  leaveTimePrecisionLevel: string;
  approvalId: number;
  approvalType: string;
}

interface CreateBy {
  id: string;
  fullName: string;
  fonctionName: string;
  image: string;
  date: Date;
  approvelCount: number;
  approvelDone: number;
  approvelTaux: number;
}

interface Approval {
  id: string;
  fullName: string;
  fonctionName: string;
  image: string;
  level: string;
  date: Date;
  isApproved: boolean;
  status: string;
  raison: string | null;
}

// interface DepartmentRequest {}

interface DemandeUser {
  id: string;
  firstName: string | null;
  fullName: string;
  lastName: string | null;
  cin: string | null;
  email: string | null;
  image: string;
  imageContent: string | null;
  imageFile: string | null;
  path: string | null;
  phoneNumber1: string | null;
  phoneNumber: string | null;
  phoneNumber2: string | null;
  fk_Fonction: number | null;
  fk_Departement: number | null;
  departementName: string;
  fonctionName: string;
  siteName: string;
  genre: string | null;
  linkdin: string | null;
  listUsers: SelectUsers[] | null;
  role: string;
  files: File[] | null;
  filesContent: File[] | null;
  filesNames: File[] | null;
}
interface InfoRowProps {
  label: string;
  value: string | React.JSX.Element;
  color?: 'green' | 'default';
}

interface Decision {
  id: number;
  levelType: string;
  raison: string;
}

interface SelectUsers {
  value: string;
  text: string;
  smallText: string | null;
  imagePath: string | null;
  labelGroup: string | null;
  valueGroup: string | null;
  selected: boolean;
  type: string | null;
  date: string | null;
  order: number | null;
}

interface LeaveType {
  id: number;
  title: string;
  color: string;
  statut: boolean;
  isEditable: boolean;
}

interface LeaveList {
  list: LeaveType[];
  updatedBy: string;
  updatedDate: string;
}

interface Schedule {
  startDate: Date | string | null;
  endDate: Date | string | null;
  morning: boolean;
  afternoon: boolean;
  user_Id: string;
  fk_RegimeType: number | null;
  startTime?: string | null;
  endTime?: string | null;
}

interface WorkRegimeData {
  id: string;
  fk_Htravail?: number;
  fk_RegimeType: number;
}

interface ReportRequest {
  typeId: string;
  userId: string;
  year: number;
  month: number;
  fullYear: boolean;
  report: boolean;
}

interface Filter {
  filterName: string;
  filterValue: string | number | (string | number)[];
}

interface FiltersDemande {
  searchValue: string;
  filter: Filter[];
}

type TempFiltersItemD = {
  TypeConge?: string;
  status?: string;
  range_min?: number;
  range_max?: number;
  date_created_min: string;
  date_created_max: string;
};

type TempFiltersD = {
  filters: TempFiltersItemD;
};

type SearchD = {
  value: string;
  regex: boolean;
};

type OrderD = {
  column: string;
  dir: 'asc' | 'desc';
  custom: boolean;
};

type RequestD = {
  start: number;
  length: number;
  search: SearchD;
  order: OrderD[];
  status: number[];
  filters: {
    date_created_min: string | null;
    date_created_max: string | null;
    typeCongeIds: number[];
    status: number[];
    range_min: number | undefined;
    range_max: number | undefined;
    TypeConge?: string | undefined;
  };
};

interface TimelineProps {
  createBy: CreateBy;
  approval: Approval[];
  approvalId?: number;
  refetch: () => void;
}

interface UserDep {
  id: string;
  fullName: string;
  fonctionName: string;
  image: string;
  type: string;
  createDate: string;
  startDate: string;
  endDate: string;
  nbrDay: number;
}

interface SameDepartmentRequestsProps {
  requests: UserDep[];
}

interface LeaveReservationState {
  id: number;
  fk_RegimeType: number | null;
  startDate: string | null;
  endDate: string | null;
  createdDate: string;
  morning: boolean;
  afternoon: boolean;
  descriptionRequired: boolean;
  substituteRequired: boolean;
  substituteVisible: boolean;
  description: string;
  files: File[];
  filesContent: [];
  fk_User: string;
  isExcatTimeRequired: boolean;
  projectId?: string | null;
}

interface UploadedFile {
  lastModified: number;
  lastModifiedDate: Date;
  name: string;
  size: number;
  type: string;
  webkitRelativePath: string;
}

// type

interface CongeType {
  daysOff: number[];
  types: SelectItem[];
}

interface DaysOffType {
  value: {
    day: number;
    value: string;
  }[];
  periode: object;
}

interface CreateCongeType {
  id: number;
  fk_User: string;
  fk_RegimeType: string;
  startDate: string;
  endDate: string;
  afternoon: boolean;
  morning: boolean;
  description: string;
  files: File[];
  filesNames: FileType[] | null;
  projectId?: string | null;
  startTime: string | null;
  endTime: string | null;
  fk_Substitute: string | null;
}

interface ExportFilterType {
  dateMax: string;
  dateMin: string;
  departement: string;
  site: string;
  society: string;
  service: string;
  teams: string;
  fonction: string;
  type: string;
  ids: string[];
  idsNotSelected?: string[];
}

export enum TypeDemand {
  All,
  Approval,
  Permission,
}

interface DemandeTypeFilter {
  date_created_min: string | null;
  date_created_max: string | null;
  dateMin: string | null;
  dateMax: string | null;
  typeCongeIds: number[];
  status: number[];
  range_min: number | null;
  range_max: number | null;
  society: string | null;
  site: string | null;
  approval: TypeDemand | null;
}
export interface DemandeExportFilter {
  date_created_min: string | null;
  date_created_max: string | null;
  dateMin: string | null;
  dateMax: string | null;
  typeCongeIds: number[];
  status: string | null;
  range_min: string | null;
  range_max: string | null;
  society: string | null;
  site: string | null;
  ids: string[] | string;
  idsNotSelected?: string[];
}

interface DemandeType {
  start: number;
  length: number;
  search: SearchD;
  order: OrderD[];
  // status: number[];
  filters: DemandeTypeFilter;
}
interface KeySettings {
  DescriptionRequired: boolean;
  JustificatifFilesRequired: boolean;
  SubstituteRequired: boolean;
  SubstituteVisible: boolean;
  IsExcatTimeRequired: boolean;
  IsHalfDay: boolean;
  CalcByHours: boolean;
  IsProjectLinked: boolean;
}

interface DaysOffResponse {
  key: KeySettings;
  value: { day: number; value: string }[];
  periode: Record<string, unknown>;
}

export type {
  KeySettings,
  ResponseStatsConge,
  FilterDetails,
  TableFilter,
  UserData,
  User,
  MainResponse,
  CreateBy,
  Approval,
  DemandeUser,
  InfoRowProps,
  Decision,
  SelectUsers,
  LeaveType,
  LeaveList,
  Schedule,
  WorkRegimeData,
  ReportRequest,
  Filter,
  FiltersDemande,
  TempFiltersItemD,
  TempFiltersD,
  SearchD,
  OrderD,
  RequestD,
  TimelineProps,
  UserDep,
  SameDepartmentRequestsProps,
  LeaveReservationState,
  UploadedFile,
  CongeType,
  DaysOffType,
  CreateCongeType,
  ExportFilterType,
  DemandeType,
  DemandeTypeFilter,
  DaysOffResponse,
};
